import { Footer } from '@/components/Footer';
import { AuthDialogProvider } from '@/context/auth-dialog.context';
import { ModalProvider } from '@/context/modal.context';
import { IntroDialog } from '@/components/intro-dialog';
import { useIntroDialog } from '@/hooks/use-intro-dialog';
import { YandexMetrics } from '@/components/yandex-metrics';
import { Header } from '@/components/header';

interface UserLayoutProps {
  children: React.ReactNode;
}

export function UserLayout({ children }: UserLayoutProps) {
  const { showIntroDialog, closeDialog } = useIntroDialog();

  return (
    <ModalProvider>
      <AuthDialogProvider>
        <div className="user-layout min-h-screen">
          {process.env.NODE_ENV === 'production' && <YandexMetrics />}
          <Header />
          <main>{children}</main>
          <Footer />
          {showIntroDialog && <IntroDialog open={showIntroDialog} onClose={closeDialog} />}
        </div>
      </AuthDialogProvider>
    </ModalProvider>
  );
}
